import { render, staticRenderFns } from "./form-baseinfo.vue?vue&type=template&id=6170b352&scoped=true"
import script from "./form-baseinfo.vue?vue&type=script&lang=js"
export * from "./form-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./form-baseinfo.vue?vue&type=style&index=0&id=6170b352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170b352",
  null
  
)

export default component.exports